import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { UsersCheckmark } from 'components/icons'

type Props = IconProps

const GroupsPermissions: FC<Props> = (props) => {
  return <UsersCheckmark {...props} />
}

const GroupsPermissionsExports = {
  GroupsPermissions,
}

export default GroupsPermissionsExports
